// 共通系
import accountRepository from "./entity/common/accountRepository";
import notificationRepository from "./entity/common/notificationRepository";
import pictureRepository from "./entity/common/pictureRepository";
import vesselRepository from "./entity/common/vesselRepository";
import plotRepository from "./entity/common/plotRepository";
import enterprisePublicRepository from "./entity/common/enterprisePublicRepository";
import userPublicRepository from "./entity/common/userPublicRepository";
import constantRepository from "./entity/common/constantRepository";
import voyageHistoryRepository from "./entity/common/voyageHistoryRepository";
import voyageRepository from "./entity/common/voyageRepository";
import polarisRepository from "./entity/common/polarisRepository";

// 法人向けAPI系
import enterpriseRepository from "./entity/enterprise/enterpriseRepository";
import enterpriseUserRepository from "./entity/enterprise/enterpriseUserRepository";
import enterpriseVesselRepository from "./entity/enterprise/enterpriseVesselRepository";
import enterpriseCameraRepository from "./entity/enterprise/enterpriseCameraRepository";
import enterpriseVesselDocumentRepository from "./entity/enterprise/enterpriseVesselDocumentRepository";
import enterpriseVesselPictureRepository from "./entity/enterprise/enterpriseVesselPictureRepository";
import enterprisePlotRepository from "./entity/enterprise/enterprisePlotRepository";
import enterpriseLicenseRepository from "./entity/enterprise/enterpriseLicenseRepository";
import enterpriseLicensePictureRepository from "./entity/enterprise/enterpriseLicensePictureRepository";
import enterpriseVoyageHistoriesRepository from "./entity/enterprise/enterpriseVoyageHistoriesRepository";
import enterpriseVoyageHistoryPointRepository from "./entity/enterprise/enterpriseVoyageHistoryPointRepository";
import enterpriseVoyageRecordsRepository from "./entity/enterprise/enterpriseVoyageRecordsRepository";
import enterpriseVesselDisplayChannelRepository from "./entity/enterprise/enterpriseVesselDisplayChannelRepository";
import enterpriseAdminAddonRepository from "./entity/enterprise/enterpriseAdminAddonController";
import enterpriseAddonRepository from "./entity/enterprise/enterpriseAddonRepository";

// 船員管理
import enterpriseCrewRepository from "./entity/enterprise/enterpriseCrewRepository";
import enterpriseCrewRepository_v2 from "./entity/enterprise/enterpriseCrewRepository_v2";
import enterpriseCrewLaborRepository from "./entity/enterprise/enterpriseCrewLaborRepository";
import enterpriseAdminAccountRepository from "./entity/enterprise/enterpriseAdminAccountRepository";
import enterpriseAdminAccountPasswordRepository from "./entity/enterprise/enterpriseAdminAccountPasswordRepository";
import enterpriseAdminAccountPasswordCertificatesRepository from "./entity/enterprise/enterpriseAdminAccountPasswordCertificatesRepository";
import enterpriseAdminAccountCertificatesRepository from "./entity/enterprise/enterpriseAdminAccountCertificatesRepository";
import enterpriseAdminAccountInviteRepository from "./entity/enterprise/enterpriseAdminAccountInviteRepository";
import enterpriseCrewManningVesselRepository from "./entity/enterprise/enterpriseCrewManningVesselRepository";
import enterpriseManningVesselRepository from "./entity/enterprise/enterpriseManningVesselRepository";
import enterpriseManningVesselCategoryRepository from "./entity/enterprise/enterpriseManningVesselCategoryRepository";
import enterpriseManningVesselStatusRepository from "./entity/enterprise/enterpriseManningVesselStatusRepository";
import enterpriseLaborTemplateRepository from "./entity/enterprise/enterpriseLaborTemplateRepository";
import enterpriseCrewPictureRepository from "./entity/enterprise/enterpriseCrewPictureRepository";
import enterpriseCrewRoleRepository from "./entity/enterprise/enterpriseCrewRoleRepository";
import enterpriseManningVesselPictureRepository from "./entity/enterprise/enterpriseManningVesselPictureRepository";
import enterpriseCrewTimesheetRepository from "./entity/enterprise/enterpriseCrewTimesheetRepository";
import enterpriseCrewTimesheetApprovalRepository from "./entity/enterprise/enterpriseCrewTimesheetApprovalRepository";
import enterpriseCrewTimesheetRecordRepository from "./entity/enterprise/enterpriseCrewTimesheetRecordRepository";
import enterpriseCrewAccountRepository from "./entity/enterprise/enterpriseCrewAccountRepository";
import enterpriseCrewRecordBookRepository from "./entity/enterprise/enterpriseCrewRecordBookRepository";
import enterpriseCrewDayOffDayRepository from "./entity/enterprise/enterpriseCrewDayOffDayRepository";
import enterpriseCrewPayrollRepository from "./entity/enterprise/enterpriseCrewPayrollRepository.js";
import enterpriseTimesheetTaskRepository from "./entity/enterprise/enterpriseTimesheetTaskRepository";
import enterpriseManningCrewRepository from "./entity/enterprise/enterpriseManningCrewRepository";
import enterpriseCrewDataManagementRepository from "./entity/enterprise/enterpriseCrewDataManagementRepository";
import enterpriseCrewFiscalYearsRepository from "./entity/enterprise/enterpriseCrewFiscalYearsRepository";
import enterpriseCrewHavingLicenseRepository from "./entity/enterprise/enterpriseCrewHavingLicenseRepository";
import enterpriseCrewLicenseRepository from "./entity/enterprise/enterpriseCrewLicenseRepository";

// 新規法人契約
import enterpriseContractRepository from "./entity/enterprise/enterpriseContractRepository";

// 書類管理API
import enterpriseDocumentRepository from "./entity/enterprise/enterpriseDocumentRepository";

// タスクマネージャーAPI
import enterpriseBackgroundTaskRepository from "./entity/enterprise/enterpriseBackgroundTaskRepository";

// 機能拡張API
import reportRepository from "./entity/addon/vessel-report/reportRepository";
import vesselReportRepository from "./entity/addon/vessel-report/vesselReportRepository";
import vesselReportConfirmRepository from "./entity/addon/vessel-report/vesselReportConfirmRepository";
import vesselReportExportRepository from "./entity/addon/vessel-report/vesselReportExportRepository";

import portMasterVesselMasterRepository from "./entity/addon/port-master/portMasterVesselMasterRepository";
import portMasterBerthMasterRepository from "./entity/addon/port-master/portMasterBerthMasterRepository";
import portMasterEnterpriseAgencyMasterRepository from "./entity/addon/port-master/portMasterEnterpriseAgencyMasterRepository";
import portMasterAgencyMasterRepository from "./entity/addon/port-master/portMasterAgencyMasterRepository";
import portMasterPilotMasterRepository from "./entity/addon/port-master/portMasterPilotMasterRepository";
import portMasterTugBoatMasterRepository from "./entity/addon/port-master/portMasterTugBoatMasterRepository";
import portMasterVehicleMasterRepository from "./entity/addon/port-master/portMasterVehicleMasterRepository";
import portMasterRopePickingBoatMasterRepository from "./entity/addon/port-master/portMasterRopePickingBoatMasterRepository";
import portMasterTeamLeaderMasterRepository from "./entity/addon/port-master/portMasterTeamLeaderMasterRepository";
import portMasterTagMasterRepository from "./entity/addon/port-master/portMasterTagMasterRepository";
import portMasterPortSelectRepository from "./entity/addon/port-master/portMasterPortSelectRepository";
import portMasterPortColorRepository from "./entity/addon/port-master/portMasterPortColorRepository";
import portMasterPortWharfRepository from "./entity/addon/port-master/portMasterPortWharfRepository";
import portMasterTasksRepository from "./entity/addon/port-master/portMasterTasksRepository";
import portMasterDailyReportsRepository from "./entity/addon/port-master/portMasterDailyReportsRepository";
import portMasterVoucherRepository from "./entity/addon/port-master/portMasterVoucherRepository";

import ecoShipSeaRoutesRepository from "./entity/addon/eco-ship/ecoShipSeaRoutesRepository";
// Secure Dataflow
import enterpriseVesselSecureDataflowChannelRepository from "./entity/addon/secure-dataflow/enterpriseVesselSecureDataflowChannelRepository";
import m0checklistRepository from "./entity/addon/secure-dataflow/m0checklistRepository";
import m0checklistRoomRepository from "./entity/addon/secure-dataflow/m0checklistRoomRepository";
import roomRepository from "./entity/addon/secure-dataflow/roomRepository";
import sdfSeaRoutesRepository from "./entity/addon/secure-dataflow/seaRoutesRepository";
import sdfBatchDataRepository from "./entity/addon/secure-dataflow/batchDataRepository";

// EcoShipAPI
import ecoShipChannelRepository from "./entity/addon/eco-ship/ecoShipChannelRepository.js";
import ecoShipContainerCustomersRepository from "./entity/addon/eco-ship/ecoShipContainerCustomersRepository";
import ecoShipVesselContainersRepository from "./entity/addon/eco-ship/ecoShipVesselContainersRepository";
import ecoShipFuelConsumptionRepository from "./entity/addon/eco-ship/ecoShipFuelConsumptionRepository";
import ecoShipVesselContainerPicturesRepository from "./entity/addon/eco-ship/ecoShipVesselContainerPicturesRepository";

// 燃料消費月次レポートAPI
import ecoShipMonthlyFuelReportRepository from "./entity/addon/eco-ship/ecoShipMonthlyFuelReportRepository";
// 燃料消費統計レポートAPI
import ecoShipYearlyFuelReportRepository from "./entity/addon/eco-ship/ecoShipYearlyFuelReportRepository";

// 損害対応API
import hullInsuranceEnterpriseClaimReportRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseClaimReportRepository";
import hullInsuranceEnterpriseClaimItemRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseClaimItemRepository";
import hullInsuranceEnterpriseClaimTypeRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseClaimTypeRepository";
import hullInsuranceEnterpriseStatisticsRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseStatisticsRepository";
import hullInsuranceEnterpriseEnterpriseKindRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseEnterpriseKindRepository";
import hullInsuranceEnterpriseClaimReportStaffRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseClaimReportStaffRepository";
import hullInsuranceEnterpriseReportClaimTypeRepository from "./entity/addon/hull-insurance/hullInsuranceEnterpriseReportClaimTypeRepository";

//動静連絡API
import noonReportRepository from "./entity/addon/noon-reports/noonReports";

//書エネ解析API
import fuelConsumptionRepository from "./entity/addon/fuel-consumption/fuelConsumptionRepository";
import enterpriseVesselOriginsRepository from "@/api/aisea/entity/enterprise/enterpriseVesselOriginsRepository";

// operation API
import operationRepository from "./entity/addon/operation/operationRepository.js";
import operationWorkflowRepository from "./entity/addon/operation/operationWorkflowRepository";
import operationReportRepository from "./entity/addon/operation/operationReportRepository";
import operationColumnRepository from "./entity/addon/operation/operationColumnRepository.js";
import operationDepartmentRepository from "./entity/addon/operation/operationDepartmentRepository.js";
import operationAccountRepository from "./entity/addon/operation/operationAccountRepository.js";
import operationVesselRepository from "./entity/addon/operation/operationVesselRepository.js";
import operationMasterRepository from "./entity/addon/operation/operationMasterRepository";
import enterpriseWorkflowRepository from "./entity/enterprise/enterpriseWorkflowRepository";
import enterpriseFormRepository from "./entity/enterprise/enterpriseFormRepository";

// crew operator API
import enterpriseUnitRepository from "./entity/addon/crew-operator/enterpriseUnitRepository";
import enterpriseOwnerRepository from "./entity/addon/crew-operator/enterpriseOwnerRepository";
import enterpriseOwnerManningVesselTimesheetRecordRepository from "./entity/addon/crew-operator/enterpriseOwnerManningVesselTimesheetRecordRepository";
import enterpriseOwnerManningCrewRepository from "./entity/addon/crew-operator/enterpriseOwnerManningCrewRepository";
import enterpriseOwnerManningVesselRecordBookRepository from "./entity/addon/crew-operator/enterpriseOwnerManningVesselRecordBookRepository";
import enterpriseOwnerManningVesselRepository from "./entity/addon/crew-operator/enterpriseOwnerManningVesselRepository";
import enterpriseOwnerManningVesselCrewRecordBookRepository from "./entity/addon/crew-operator/enterpriseOwnerManningVesselCrewRecordBookRepository";
import enterpriseManningVesselsRepository from "./entity/addon/crew-assignment-management/enterpriseManningVesselsRepository.js";
import enterpriseOnboardingCrewsRepository from "./entity/addon/crew-assignment-management/enterpriseOnboardingCrewsRepository.js";
import enterpriseAshoreCrewsRepository from "./entity/addon/crew-assignment-management/enterpriseAshoreCrewsRepository.js";
import enterpriseManningVesselAlertsRepository from "./entity/addon/crew-assignment-management/enterpriseManningVesselAlertsRepository.js";
import enterpriseCrewsAlertsRepository from "./entity/addon/crew-assignment-management/enterpriseCrewsAlertsRepository.js";
import enterpriseCrewsRolesRepository from "./entity/addon/crew-assignment-management/enterpriseCrewsRolesRepository.js";
import enterpriseCrewFiscalYearSummariesRepository from "./entity/addon/crew-assignment-management/enterpriseCrewFiscalYearSummariesRepository.js";
import enterpriseManningVesselRolePositionRepository from "./entity/addon/crew-assignment-management/enterpriseManningVesselRolePositionRepository.js";
import enterpriseAssignmentScoringCategoriesRepository from "./entity/addon/crew-assignment-management/enterpriseAssignmentScoringCategoriesRepository.js";
import enterpriseCrewsBasicConditionsRepository from "./entity/addon/crew-assignment-management/enterpriseCrewsBasicConditionsRepository.js";
import enterpriseCrewsFiscalYeatDefaultsRepository from "./entity/addon/crew-assignment-management/enterpriseCrewsFiscalYeatDefaultsRepository.js";
import enterpriseCrewAlertSettingsRepository from "./entity/addon/crew-assignment-management/enterpriseCrewAlertSettingsRepository.js";
import enterpriseManningVesselCrewRepository from "./entity/enterprise/enterpriseManningVesselCrewRepository.js";
import enterpriseManningVesselCrewTodoRepository from "./entity/enterprise/enterpriseManningVesselCrewTodoRepository.js";
import enterpriseManningVesselCrewVisitRecordRepository from "./entity/enterprise/enterpriseManningVesselCrewVisitRecordRepository.js";
import enterpriseManningVesselCrewResposibilitiesRepository from "./entity/enterprise/enterpriseManningVesselCrewResposibilitiesRepository.js";
import enterpriseManningStatusRepository from "./entity/addon/crew-assignment-management/enterpriseManningStatusRepository.js";
import enterpriseManningVesselRolePostionsDisplayRepository from "./entity/addon/crew-assignment-management/enterpriseManningVesselRolePostionsDisplayRepository.js";

import EnterpriseCrewSchedulerRepository from "./entity/enterprise/EnterpriseCrewSchedulerRepository.js";
import enterpriseFeaturePermissionsRepository from "./entity/enterprise/enterpriseFeaturePermissionsRepository.js";
const repositories = {
  // 共通系
  account: accountRepository,
  notification: notificationRepository,
  picture: pictureRepository,
  plot: plotRepository,
  enterprisePublic: enterprisePublicRepository,
  userPublic: userPublicRepository,
  constant: constantRepository,
  vessel: vesselRepository,
  voyageHistory: voyageHistoryRepository,
  voyage: voyageRepository,
  polaris: polarisRepository,

  // 法人向けAPI系
  enterprise: enterpriseRepository,
  enterpriseUser: enterpriseUserRepository,
  enterpriseVessel: enterpriseVesselRepository,
  enterpriseCamera: enterpriseCameraRepository,
  enterpriseVesselDocument: enterpriseVesselDocumentRepository,
  enterpriseVesselPicture: enterpriseVesselPictureRepository,
  enterprisePlot: enterprisePlotRepository,
  enterpriseLicense: enterpriseLicenseRepository,
  enterpriseLicensePicture: enterpriseLicensePictureRepository,
  enterpriseVoyageHistories: enterpriseVoyageHistoriesRepository,
  enterpriseVoyageHistoryPoint: enterpriseVoyageHistoryPointRepository,
  enterpriseVoyageRecords: enterpriseVoyageRecordsRepository,
  enterpriseVesselDisplayChannel: enterpriseVesselDisplayChannelRepository,
  enterpriseAdminAddon: enterpriseAdminAddonRepository,
  enterpriseVesselOrigins: enterpriseVesselOriginsRepository,
  enterpriseAddonRepository: enterpriseAddonRepository,

  // 船員管理
  enterpriseCrew: enterpriseCrewRepository,
  enterpriseCrewLabor: enterpriseCrewLaborRepository,
  enterpriseAdminAccount: enterpriseAdminAccountRepository,
  enterpriseAdminAccountPassword: enterpriseAdminAccountPasswordRepository,
  enterpriseAdminAccountPasswordCertificates: enterpriseAdminAccountPasswordCertificatesRepository,
  enterpriseAdminAccountCertificates: enterpriseAdminAccountCertificatesRepository,
  enterpriseAdminAccountInvite: enterpriseAdminAccountInviteRepository,
  enterpriseCrewManningVessel: enterpriseCrewManningVesselRepository,
  enterpriseManningVessel: enterpriseManningVesselRepository,
  enterpriseManningVesselCategory: enterpriseManningVesselCategoryRepository,
  enterpriseManningVesselStatus: enterpriseManningVesselStatusRepository,
  enterpriseCrewPicture: enterpriseCrewPictureRepository,
  enterpriseLaborTemplate: enterpriseLaborTemplateRepository,
  enterpriseCrewTimesheet: enterpriseCrewTimesheetRepository,
  enterpriseCrewTimesheetApproval: enterpriseCrewTimesheetApprovalRepository,
  enterpriseCrewTimesheetRecord: enterpriseCrewTimesheetRecordRepository,
  enterpriseCrewRole: enterpriseCrewRoleRepository,
  enterpriseManningVesselPicture: enterpriseManningVesselPictureRepository,
  enterpriseCrewAccount: enterpriseCrewAccountRepository,
  enterpriseCrewRecordBook: enterpriseCrewRecordBookRepository,
  enterpriseCrewDayOffDay: enterpriseCrewDayOffDayRepository,
  enterpriseCrewPayroll: enterpriseCrewPayrollRepository,
  enterpriseTimesheetTask: enterpriseTimesheetTaskRepository,
  enterpriseManningCrew: enterpriseManningCrewRepository,
  enterpriseCrewDataManagement: enterpriseCrewDataManagementRepository,
  enterpriseCrewFiscalYears: enterpriseCrewFiscalYearsRepository,
  enterpriseCrew_v2: enterpriseCrewRepository_v2,
  enterpriseCrewHavingLicense: enterpriseCrewHavingLicenseRepository,
  enterpriseCrewLicense: enterpriseCrewLicenseRepository,
  enterpriseManningVesselCrew: enterpriseManningVesselCrewRepository,
  enterpriseManningVesselCrewTodo: enterpriseManningVesselCrewTodoRepository,
  enterpriseManningVesselCrewVisitRecord: enterpriseManningVesselCrewVisitRecordRepository,
  enterpriseManningVesselCrewResposibilities: enterpriseManningVesselCrewResposibilitiesRepository,

  // 新規法人契約
  enterpriseContract: enterpriseContractRepository,

  //書類管理API
  enterpriseDocument: enterpriseDocumentRepository,

  // タスクマネージャーAPI
  enterpriseBackgroundTask: enterpriseBackgroundTaskRepository,

  // 機能拡張API
  report: reportRepository,
  vesselReport: vesselReportRepository,
  vesselReportConfirm: vesselReportConfirmRepository,
  vesselReportExport: vesselReportExportRepository,

  portMasterVesselMaster: portMasterVesselMasterRepository,
  portMasterBerthMaster: portMasterBerthMasterRepository,
  portMasterEnterpriseAgencyMaster: portMasterEnterpriseAgencyMasterRepository,
  portMasterAgencyMaster: portMasterAgencyMasterRepository,
  portMasterPilotMaster: portMasterPilotMasterRepository,
  portMasterTugBoatMaster: portMasterTugBoatMasterRepository,
  portMasterVehicleMaster: portMasterVehicleMasterRepository,
  portMasterRopePickingBoatMaster: portMasterRopePickingBoatMasterRepository,
  portMasterTeamLeaderMaster: portMasterTeamLeaderMasterRepository,
  portMasterTagMaster: portMasterTagMasterRepository,
  portMasterPortSelect: portMasterPortSelectRepository,
  portMasterPortColor: portMasterPortColorRepository,
  portMasterPortWharf: portMasterPortWharfRepository,
  portMasterTasks: portMasterTasksRepository,
  portMasterDailyReports: portMasterDailyReportsRepository,
  portMasterVoucher: portMasterVoucherRepository,

  // Secure Dataflow
  enterpriseVesselSecureDataflowChannel: enterpriseVesselSecureDataflowChannelRepository,
  m0checklist: m0checklistRepository,
  m0checklistRoom: m0checklistRoomRepository,
  room: roomRepository,
  sdfSeaRoutes: sdfSeaRoutesRepository,
  sdfBatchData: sdfBatchDataRepository,

  ecoShipSeaRoutes: ecoShipSeaRoutesRepository,
  // EcoShipAPI
  ecoShipChannel: ecoShipChannelRepository,
  ecoShipContainerCustomerMaster: ecoShipContainerCustomersRepository,
  ecoShipVesselContainers: ecoShipVesselContainersRepository,
  ecoShipFuelConsumptions: ecoShipFuelConsumptionRepository,
  ecoShipVesselContainerPictures: ecoShipVesselContainerPicturesRepository,

  // 燃料消費月次レポートAPI
  ecoShipMonthlyFuelReport: ecoShipMonthlyFuelReportRepository,
  // 燃料消費統計レポートAPI
  ecoShipYearlyFuelReport: ecoShipYearlyFuelReportRepository,

  //損害対応
  hullInsuranceEnterpriseClaimReport: hullInsuranceEnterpriseClaimReportRepository,
  hullInsuranceEnterpriseClaimItem: hullInsuranceEnterpriseClaimItemRepository,
  hullInsuranceEnterpriseClaimType: hullInsuranceEnterpriseClaimTypeRepository,
  hullInsuranceEnterpriseStatistics: hullInsuranceEnterpriseStatisticsRepository,
  hullInsuranceEnterpriseEnterpriseKind: hullInsuranceEnterpriseEnterpriseKindRepository,
  hullInsuranceEnterpriseClaimReportStaff: hullInsuranceEnterpriseClaimReportStaffRepository,
  hullInsuranceEnterpriseReportClaimType: hullInsuranceEnterpriseReportClaimTypeRepository,
  //動静連絡API
  noonReport: noonReportRepository,
  //アブログAPI
  fuelConsumption: fuelConsumptionRepository,

  // operation API
  operation: operationRepository,
  operationWorkflow: operationWorkflowRepository,
  operationReport: operationReportRepository,
  operationColumn: operationColumnRepository,
  operationDepartment: operationDepartmentRepository,
  operationAccount: operationAccountRepository,
  operationVessel: operationVesselRepository,
  operationMaster: operationMasterRepository,
  enterpriseWorkflow: enterpriseWorkflowRepository,
  enterpriseForm: enterpriseFormRepository,

  // crew operator API
  enterpriseUnit: enterpriseUnitRepository,
  enterpriseOwner: enterpriseOwnerRepository,
  enterpriseOwnerManningVesselTimesheetRecord: enterpriseOwnerManningVesselTimesheetRecordRepository,
  enterpriseOwnerManningCrew: enterpriseOwnerManningCrewRepository,
  enterpriseOwnerManningVesselRecordBook: enterpriseOwnerManningVesselRecordBookRepository,
  enterpriseOwnerManningVessel: enterpriseOwnerManningVesselRepository,
  enterpriseOwnerManningVesselCrewRecordBook: enterpriseOwnerManningVesselCrewRecordBookRepository,
  enterpriseManningVessels: enterpriseManningVesselsRepository,
  enterpriseOnboardingCrews: enterpriseOnboardingCrewsRepository,
  enterpriseAshoreCrews: enterpriseAshoreCrewsRepository,
  enterpriseManningVesselAlerts: enterpriseManningVesselAlertsRepository,
  enterpriseCrewsAlerts: enterpriseCrewsAlertsRepository,
  enterpriseCrewsRoles: enterpriseCrewsRolesRepository,
  enterpriseCrewFiscalYearSummaries: enterpriseCrewFiscalYearSummariesRepository,
  enterpriseManningVesselRolePosition: enterpriseManningVesselRolePositionRepository,
  enterpriseAssignmentScoringCategories: enterpriseAssignmentScoringCategoriesRepository,
  enterpriseCrewsBasicConditions: enterpriseCrewsBasicConditionsRepository,
  enterpriseCrewsFiscalYeatDefaults: enterpriseCrewsFiscalYeatDefaultsRepository,
  enterpriseCrewAlertSettings: enterpriseCrewAlertSettingsRepository,
  enterpriseManningStatus: enterpriseManningStatusRepository,
  enterpriseManningVesselRolePostionsDisplay: enterpriseManningVesselRolePostionsDisplayRepository,
  enterpriseCrewScheduler: EnterpriseCrewSchedulerRepository,

  // 機能権限API
  enterpriseFeaturePermissions: enterpriseFeaturePermissionsRepository,
};

export const AiseaApiFactory = {
  get: name => repositories[name],
};
